import React from "react";
import { Box, Typography, Grid, TextField, MenuItem, Paper } from "@mui/material";
import { Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";

const GeneralComponent = ({ categories, control, withCategories, errors }) => {
  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          تفاصيل الطلب
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{ 
          p: 3, 
          borderRadius: "12px",
          border: "1px solid #e0e0e0"
        }}
      >
        <Grid spacing={withCategories ? 3 : 0} container>
        {withCategories && (
          <Grid item xs={12} md={4}>
            <Typography sx={{ fontWeight: "bold" }}>تصنيف الطلب</Typography>

            <Controller
              name="category"
              control={control}
              defaultValue="" // Add default value to prevent undefined
              rules={{
                required: "هذا الحقل مطلوب",
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  select
                  fullWidth
                  variant="outlined"
                  InputProps={{
                    placeholder: "",
                  }}
                  value={field.value || ""} // Ensure value is not undefined
                  FormHelperTextProps={{
                    sx: {
                      textAlign: "start",
                    },
                  }}
                  error={!!errors.category}
                  helperText={
                    errors.category ? errors.category.message : ""
                  }
                >
                  {categories.map((option) => (
                    <MenuItem key={option.name} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
              )}
            />
          </Grid>
        )}
        <Grid item xs={12} md={withCategories ? 8 : 12}>
          <Typography sx={{ fontWeight: "bold" }}>التفاصيل</Typography>
          <Controller
            name="details"
            control={control}
            rules={{
              required: false,
            }}
            render={({ field }) => (
              <TextField
                {...field}
                fullWidth
                multiline
                minRows={1}
                maxRows={8}
                variant="outlined"
                InputProps={{
                  placeholder: "",
                }}
              />
            )}
          />
        </Grid>
      </Grid>
      </Paper>
    </>
  );
};

export default GeneralComponent;
